(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auran-planning-guide"] && !Shopify.designMode) return;
  try {
    
  function openAuranRoomCollection() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    const link = Array.from(document.querySelectorAll('[data-auran-room-anchor]')).find(item => item.dataset.auranRoomAnchor === window.location.hash);
    if (!link) return;
    const target = new URL(link.href);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    window.location.replace(target.href);
  }
  openAuranRoomCollection();
  window.addEventListener('hashchange', openAuranRoomCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auran-project-inquiry"] && !Shopify.designMode) return;
  try {
    
  function populateInquiryProduct(root) {
    const product = new URLSearchParams(window.location.search).get('product');
    if (!product) return;
    root.querySelectorAll('[data-inquiry-product]').forEach((input) => {
      if (!input.value) input.value = product.slice(0, 250);
    });
  }
  populateInquiryProduct(document);
  document.addEventListener('shopify:section:load', (event) => populateInquiryProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auran-trade-program"] && !Shopify.designMode) return;
  try {
    
  function initializeTradeFormStatus(root) {
    const panels = root.querySelectorAll('.at-application__form');
    panels.forEach((panel) => {
      if (panel.dataset.statusInitialized) return;
      panel.dataset.statusInitialized = 'true';
      const status = panel.querySelector('[data-trade-form-status]');
      if (!status) return;
      const started = Date.now();
      const check = () => {
        if (!panel.isConnected) return true;
        const host = panel.querySelector('shopify-forms-embed');
        const form = host?.shadowRoot?.querySelector('form');
        if (form && form.getBoundingClientRect().height > 0) {
          status.hidden = true;
          return true;
        }
        if (Date.now() - started >= 8000) {
          status.querySelector('[data-trade-form-loading]').hidden = true;
          status.querySelector('[data-trade-form-delayed]').hidden = false;
        }
        return Date.now() - started >= 120000;
      };
      if (check()) return;
      const interval = setInterval(() => {
        if (check()) clearInterval(interval);
      }, 250);
      window.addEventListener('pagehide', () => clearInterval(interval), { once: true });
    });
  }
  initializeTradeFormStatus(document);
  document.addEventListener('shopify:section:load', (event) => initializeTradeFormStatus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
